module.exports = __webpack_public_path__ + "img/ic_check_layer4.94c14fa1.png";